export const UMB_ENTITY_IS_TRASHED_CONDITION_ALIAS = 'Umb.Condition.EntityIsTrashed';
